import Box from '@mui/material/Box';

export default function Loading() {
  // TODO: use a loading icon
  return <Box>Loading...</Box>;
}
